import { CustomerForm } from '../../../../types/customerForm'
import { CustomerFormInitialValues } from '../../types/customerForm/customerFormInitialValues'
import { PredefinedCustomerValues } from '../../types/customerForm/predefinedCustomerValues'
import { getCustomerFormDefaultValues } from './getCustomerFormDefaultValues'

interface GetCustomerFormCreatingValuesProps {
  initialValues?: CustomerFormInitialValues
  predefinedCustomerValues?: PredefinedCustomerValues
}

export const getCustomerFormCreatingValues = (props: GetCustomerFormCreatingValuesProps): Partial<CustomerForm> => {
  const { initialValues, predefinedCustomerValues } = props
  const defaultValues = getCustomerFormDefaultValues(predefinedCustomerValues)

  if (!initialValues) {
    return defaultValues
  }

  return {
    ...defaultValues,
    ...initialValues,
    address: { ...defaultValues.address, ...initialValues.address },
  }
}
